import { render, staticRenderFns } from "./RecordedTokens.vue?vue&type=template&id=33b8332f"
import script from "./RecordedTokens.vue?vue&type=script&lang=js"
export * from "./RecordedTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports